import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useFounderAuth } from "../context/FounderAuthContext";
import { evaluateFounderProtectedRouteGuard } from "../services/founderRouteGuard";

type FounderProtectedRouteProps = {
  children: ReactNode;
};

export function FounderProtectedRoute({ children }: FounderProtectedRouteProps) {
  const { user, isLoading } = useFounderAuth();
  const location = useLocation();
  const decision = evaluateFounderProtectedRouteGuard(
    { isLoading, user },
    location.pathname,
  );

  if (decision.action === "loading") {
    return (
      <div className="oac-founder-shell oac-founder-shell--loading">
        <p className="oac-founder-shell__loading">Loading...</p>
      </div>
    );
  }

  if (decision.action === "redirect") {
    return <Navigate replace state={decision.state} to={decision.to} />;
  }

  return children;
}
